import { Component, OnInit, ViewContainerRef, Input } from '@angular/core';
import { PaymentreceiptService } from '../../../../_services/paymentreceipt/paymentreceipt.service';
import { utilityService } from '../../../../sharedcomponents/commonservice/utility.service';
import { AppSettings, PaymentType, enumStatusCodeList } from '../../../../sharedcomponents/_common/constants/app.constants';
import { Router, ActivatedRoute } from '@angular/router';
import { SendMoneyService } from '../../../../_services/sendmoneyservice/sendmoneyservice';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { AboutUsComponent } from '../../../../sharedcomponents/about-us/about-us.component';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { geolocation } from '../../../../sharedcomponents/commonservice/geolocation/geoloc';
import { SendMoneyDetail } from '../../../../models/sendmoney/sendmoney';
import { ReceiptModel } from '../../../../models/Receipt/receiptModel';
import { SharepromotainalPopupComponent } from '../../../../sharedcomponents/sharepromotionalcode/sharepromotainal-popup/sharepromotainal-popup.component';
import { TransactionHistoryService } from '../../../../_services/transaction/transaction-history.service';
import { ShopingCart } from 'app/models/dashboard/cart/mywallet.currentcart.Modal';
@Component({
  selector: 'app-payment-receipt-debitcard',
  templateUrl: './payment-receipt-debitcard.component.html',
  styleUrls: ['./payment-receipt-debitcard.component.css'],
  providers: [ReceiptModel]
})
export class PaymentReceiptDebitcardComponent implements OnInit {
  receiptData: any = [];
  agentImgData: any = {};
  img: any = {};
  customerCareNumber;
  selectedIndex;
  showBothScreen;
  mobileScreen;
  sendMoneyDetail: SendMoneyDetail;
  OrderList = [];
  OrderStatusList = [];
  constructor(
    private paymentreceipt: PaymentreceiptService,
    public utilserv: utilityService,
    private router: Router,
    public recptModel: ReceiptModel,
    public modal: Modal,
    public translate: TranslateService,
    private vcRef: ViewContainerRef,
    public geoloc: geolocation,
    public sendMoneyService: SendMoneyService,
    private transactionHistoryService: TransactionHistoryService
  ) {
    const CountryObject = this.geoloc.getCountryObject();
    this.customerCareNumber = this.utilserv.getCustomerCarePhone(CountryObject);
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
  }

  ngOnInit() {
    const path = this.router.url.split('/')[1];
    if (path == 'PaymentReceipt') {
      let PageFlow = sessionStorage.PageFlow;
      if (PageFlow == 'repeatorder') {
        if (this.sendMoneyDetail.agentDetails.CountryTo == '' || this.sendMoneyDetail.agentDetails.CountryTo == undefined) {
          if (sessionStorage.RepeatOrderFlow != undefined && sessionStorage.RepeatOrderFlow != '') {
            this.router.navigate(['/' + sessionStorage.RepeatOrderFlow]);
          } else {
            this.router.navigate(['/repeatorderlist']);
          }
          return;
        }
      } else if (PageFlow == 'sendmoney') {
        if (this.sendMoneyDetail.isData == false) {
          this.router.navigate(['/dashboard']);
          return;
        }
      }

      this.initializeReceiptData(this.sendMoneyDetail);
      this.OrderList = new Array<ShopingCart>();
      this.OrderList.push(this.utilserv.getObjectText(this.sendMoneyDetail.transactionId));
      this.getOrderStatus();
    } else {
      const callSetStore = this.paymentreceipt.getCartReceiptData().subscribe(data => {
        this.receiptData = data;
        if (callSetStore !== undefined) {
          callSetStore.unsubscribe();
        }
      });

      this.OrderList = new Array<ShopingCart>();
      this.receiptData.forEach(element => {
        this.OrderList.push(this.utilserv.getObjectText(element.ItemId));
      });
      this.getOrderStatus();
      this.receiptData.forEach(
        element => {
          if (this.recptModel.DeliveryMethod == '2') {
            this.utilserv.busy = this.sendMoneyService.getBankLogo(element).subscribe(data => {
              if (data.HasDefaultImage == true) {
                this.agentImgData = '';
              } else {
                this.agentImgData = 'data:image/gif;base64,' + data.BankImageData;
              }
              this.recptModel.imageData = this.agentImgData;
              this.receiptData.push(this.recptModel);
            });
          } else {
            this.utilserv.busy = this.sendMoneyService.getPayerLogo(element).subscribe(
              data => {
                if (data.HasDefaultImage == true) {
                  this.agentImgData = '';
                } else {
                  this.agentImgData = 'data:image/gif;base64,' + data.PayingAgentImageData;
                }
                element.imageData = this.agentImgData;
              },
              error => {
                //console.log('Unable to fetch Branch Image' + error);
              }
            );
          }
        },
        error => {
          //console.log('Unable to fetch Receipt' + error);
        }
      );
      this.paymentreceipt.setIndivisualorderData(this.receiptData[0]);
      if (this.receiptData.length == 0) {
        this.router.navigate(['/dashboard']);
      }
    }
  }

  initializeReceiptData(data) {
    this.recptModel.BeneficiaryName =
      this.utilserv.getObjectText(data.beneficiaryDetails.FirstName) +
      ' ' +
      this.utilserv.getObjectText(data.beneficiaryDetails.LastName) +
      ' ' +
      this.utilserv.getObjectText(data.beneficiaryDetails.AdditionalLastName); // data.userDetails.firstName + data.userDetails.lastName;
    this.recptModel.CountryCodeTo = data.pickupTypeDetails.countryName;
    this.recptModel.TransferAmount = data.paymentDetails.destAmount;
    this.recptModel.AmountLocal = data.paymentDetails.srcAmount;
    this.recptModel.Commission = data.paymentDetails.processingFee;

    this.recptModel.CurrencyCodeFrom = data.paymentDetails.srcCurrCode;
    this.recptModel.CurrencyCodeTo = data.paymentDetails.destCurrCode;
    this.recptModel.PayingAgent = data.agentDetails.AgentName;
    // this.recptModel.DeliveryMethod = data.agentDetails.DeliveryMethod;
    if (data.agentDetails.DeliveryMethod == 2) {
      this.recptModel.PayingAgent = data.bankAccountDetails.BankName;
      this.recptModel.BankId = data.bankAccountDetails.BankId;
    }

    this.recptModel.PayingAgentLocation = data.branchDetails.PayingAgentName;
    // Commented By Bharat ,Date -20/03/2019(Client reported issue shareCredit will derrive from user)
    // this.recptModel.MarketingBalance = data.paymentDetails.shareCredit;
    this.recptModel.MarketingBalance = data.userDetails.MarketingBalance;

    this.recptModel.TotalAmount = data.paymentDetails.totalAmount;
    this.recptModel.Rate = data.paymentDetails.exchangeRate;
    this.recptModel.DeliveryMethod = this.utilserv.getObjectText(data.pickupTypeDetails.pickupType);

    this.paymentreceipt.setIndivisualorderData(this.recptModel);
    this.recptModel.PayingAgentId = this.utilserv.getObjectText(data.agentDetails.PayingAgentId);
    this.recptModel.ProgramId = this.utilserv.getObjectText(data.agentDetails.ProgramId);
    this.recptModel.PayingAgentLocationId = this.utilserv.getObjectText(data.agentDetails.LocationId);
    this.recptModel.ItemId = this.utilserv.getObjectText(data.transactionId);

    const agentDetail: any = {};

    agentDetail.PayingAgentId = this.utilserv.getObjectText(data.agentDetails.PayingAgentId);
    agentDetail.BankName = this.utilserv.getObjectText(data.bankAccountDetails.BankName);
    agentDetail.BankId = this.utilserv.getObjectText(data.bankAccountDetails.BankId);
    if (this.recptModel.DeliveryMethod == '2') {
      this.utilserv.busy = this.sendMoneyService.getBankLogo(agentDetail).subscribe(data => {
        if (data.HasDefaultImage == true) {
          this.agentImgData = '';
        } else {
          this.agentImgData = 'data:image/gif;base64,' + data.BankImageData;
        }
        this.recptModel.imageData = this.agentImgData;
        this.receiptData.push(this.recptModel);
      });
    } else {
      this.utilserv.busy = this.sendMoneyService.getPayerLogo(agentDetail).subscribe(data => {
        if (data.HasDefaultImage == true) {
          this.agentImgData = '';
        } else {
          this.agentImgData = 'data:image/gif;base64,' + data.PayingAgentImageData;
        }
        this.recptModel.imageData = this.agentImgData;
        this.receiptData.push(this.recptModel);
      });
    }
  }
  receiptdetail(rowselcetedIndex, data) {
    this.selectedIndex = rowselcetedIndex;

    this.paymentreceipt.setIndivisualorderData(data);

    // if(this.showBothScreen === 'false' && this.mobileScreen === 'true'){
    // this.router.navigate(['/PaymentReceiptDebitcardindividual']);}
    this.mobileScreen = true;
    this.showBothScreen = true;
  }

  opentermsofuse(objtext) {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    let modalData: any = {};
    modalData.Title = this.translate.instant('Common_lblTermsConditions');
    modalData.URL = objtext;
    modalData.Action = this.translate.instant('Common_lblOk');
    return this.modal.open(AboutUsComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {});
    });
  }
  ValidateMobileScreen(screen) {
    this.showBothScreen = screen.showBothScreen;
    this.mobileScreen = screen.mobileScreen;
  }
  back() {
    this.mobileScreen = true;
    this.showBothScreen = false;
  }

  openShareModal() {
    let modalData: any = {};
    return this.modal.open(SharepromotainalPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {});
    });
  }

  getOrderStatus() {
    const _self = this;
    const refFun = function() {
      _self.transactionHistoryService.getOrderItemStatus(_self.OrderList).subscribe(
        data => {
          _self.OrderList = new Array<ShopingCart>();
          if (data.Envelope.Body.OrderStatusResponse.StatusCode == enumStatusCodeList.SUCCESS) {
            _self.OrderStatusList = _self.utilserv.getArray(data.Envelope.Body.OrderStatusResponse.OrdersStatus.CartOrderStatus);
            _self.receiptData.forEach(element => {
              element.PIN = _self.utilserv.getObjectText(_self.getOrderStatusObj(_self.utilserv.getObjectText(element.ItemId)).PIN);
              if (element.PIN == '') {
                _self.OrderList.push(_self.utilserv.getObjectText(element.ItemId));
              }
            });
            if (_self.OrderList.length > 0) {
              setTimeout(refFun, 5000);
            }
          }
        },
        error => {
          //console.log('Unable to getOrderStatus' + error);
          if (_self.OrderList.length > 0) {
            setTimeout(refFun, 5000);
          }
        }
      );
    };
    refFun();
  }
  getOrderStatusObj(item): any {
    const _self = this;
    let obj: any = {};
    obj = this.OrderStatusList.filter(element => {
      return _self.utilserv.getObjectText(element.ItemId) == _self.utilserv.getObjectText(item);
    });
    return obj[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/dash-board/shoppingcart/payment-receipt-debitcard/payment-receipt-debitcard-detail/payment-receipt-debitcard.component.ts